/**
 * Resolved widget configuration. Read once at module load.
 *
 * Resolution order for the agent id (first non-empty wins):
 *   1. window.NEUTRIX_AGENT_ID  (runtime override — useful for staging)
 *   2. import.meta.env.VITE_NEUTRIX_AGENT_ID  (build-time, from .env)
 *
 * Until an agent id is set, the widget renders in "demo" mode: the orb pulses
 * but clicking it shows a friendly "agent not configured" caption. This keeps
 * the playground useful before the ElevenLabs agent is provisioned.
 */

declare global {
  interface Window {
    NEUTRIX_AGENT_ID?: string;
  }
}

function resolveAgentId(): string | null {
  const fromWindow = typeof window !== 'undefined' ? window.NEUTRIX_AGENT_ID : undefined;
  if (typeof fromWindow === 'string' && fromWindow.length > 0) return fromWindow;

  const fromEnv = import.meta.env.VITE_NEUTRIX_AGENT_ID;
  if (typeof fromEnv === 'string' && fromEnv.length > 0) return fromEnv;

  return null;
}

export const config = {
  agentId: resolveAgentId(),
  /** Visitor-context dynamic variables passed to the agent at session start. */
  buildDynamicVariables(): Record<string, string> {
    if (typeof window === 'undefined') return {};
    const url = new URL(window.location.href);
    const utm = url.searchParams.get('utm_source') ?? '';
    return {
      page_url: window.location.href,
      utm_source: utm,
      visitor_locale: navigator.language || 'en-US',
    };
  },
};
